import api from './api';
import { UsageSummary, DailyUsage } from '../types';

export const usageService = {
  getSummary: () => api.get<UsageSummary>('/usage/summary'),
  getDailyUsage: (apiKeyId: number, from?: Date, to?: Date) => 
    api.get<DailyUsage[]>(`/usage/daily/${apiKeyId}`, { 
      params: { 
        from: from?.toISOString(), 
        to: to?.toISOString() 
      } 
    }),
};